import styled from "styled-components";
import { theme } from "@ifgengineering/component-library";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ContentItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 32px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.SLATE200};
  background-color: ${theme.colors.SLATE100};
`;
